import React, { useRef } from 'react';
import { Controller } from 'react-hook-form';

const EnhancedController = (props) => {
  const ref = useRef();
  if (ref.current && !props.control.inputRefs.current[props.name]) {
    props.control.inputRefs.current[props.name] = ref;
  }
  return <Controller {...props} inputRef={ref} />;
};

export default EnhancedController;
